﻿import * as React from 'react';
import './Button.css';

interface IButtonProps {
    type?: string;
    text: string;
    id?: string;
    width?: string;
    notaction?: boolean;
    onClick: () => void;
    fontWeightLight?: boolean;
}

const Button = (props: IButtonProps) => {
    let className: string = 'button_def';
    let width: string = props.width !== undefined ? props.width : '104px';
    let id: string = props.id !== undefined ? props.id : '';

    if (props.notaction) className = className + '_not_activ';

    if (props.type !== undefined) {
        if (props.type == 'color') className = className + ' flooded';
        else if (props.type == 'white') className = className + ' white';
        else className = className + ' normal';
    } else className = className + ' normal';

    let sty = {
        width: width
    };

    return props.notaction ? (
        <div className={className} style={sty} key={id + props.text}>
            <p style={{ fontWeight: props.fontWeightLight ? 'lighter' : 'normal' }}>{props.text}</p>
        </div>
    ) : (
        <div onClick={props.onClick} className={className} style={sty} key={id + props.text}>
            <p style={{ fontWeight: props.fontWeightLight ? 'lighter' : 'normal' }}>{props.text}</p>
        </div>
    );
};

export default Button;
